// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://isweehdfqdhcerukawcv.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imlzd2VlaGRmcWRoY2VydWthd2N2Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTM2NDU0MzIsImV4cCI6MjA2OTIyMTQzMn0.q_T_VlUC7-_T99WH1n6cuplhY_6d-SEKxIXRggtkpiM";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});